import Tween from 'tween.js';
export { Tween as default };